<template>
	<div class="c-folder-sidebar">
		<div class="c-list">
			<div class="c-list__item" @click="addFolder">
				<div class="c-list__content">
					<span class="muted"> Folders </span>
				</div>
			</div>
			<div
				:class="[
					'c-list__item dull interactive',
					{ active: folder._id === currentFolder },
					{ drag: drag == true },
				]"
				v-for="folder in folders"
				:key="folder._id"
				@click="onFolderClick(folder)"
				@dragover="onDragover"
				@drop="onDrop($event, folder)"
			>
				<folder-icon size="1x" class="c-list__icon"></folder-icon>
				<div class="c-list__content">
					{{ getTitle(folder) }}
				</div>
				<b-dropdown class="c-list__btn" variant="link">
					<template v-slot:button-content>
						<more-horizontal-icon size="1x"></more-horizontal-icon>
					</template>
					<b-dropdown-item href="#" @click.prevent="onEditFolder(folder)"
						>Edit</b-dropdown-item
					>
					<b-dropdown-item
						href="#"
						@click.prevent="onDeleteFolder(folder)"
						class="danger"
						>Delete</b-dropdown-item
					>
				</b-dropdown>
			</div>
			<div class="c-list__item interactive" @click="addFolder">
				<div class="c-list__content">
					<span> Add Folder </span>
				</div>
			</div>
		</div>
		<modalAddfolder></modalAddfolder>
		<modalEditfolder ref="editFolderModal"></modalEditfolder>
	</div>
</template>

<script>
import modalAddfolder from '@/components/modals/modal-addfolder.vue';
import modalEditfolder from '@/components/modals/modal-editfolder.vue';

import { PlusIcon, MoreHorizontalIcon, FolderIcon } from 'vue-feather-icons';

export default {
	components: {
		PlusIcon,
		MoreHorizontalIcon,
		FolderIcon,
		modalAddfolder,
		modalEditfolder,
	},
	data: function () {
		return {};
	},
	computed: {
		currentFolder: function () {
			return this.$store.getters['dashboard/folder'];
		},
		folders: function () {
			return this.$store.getters['folder/folders'];
		},
		notes: function () {
			return this.$store.getters['note/notes'];
		},
		drag: function () {
			return this.$store.getters['dashboard/drag'];
		},
	},
	methods: {
		onDragover: function (e) {
			e.preventDefault();
		},
		onDrop: function (e, folder) {
			let ids = e.dataTransfer.getData('text');
			try {
				ids = JSON.parse(ids);
			} catch (err) {
				console.log(err);
				return;
			}
			if (ids) {
				let notes = this.notes;
				let results = [];
				for (let i = 0; i < notes.length; i++) {
					if (ids.includes(notes[i].id)) {
						notes[i].folder = folder._id;
						results.push(notes[i]);
					}
				}
				this.$store.dispatch('note/bulkUpdateNotes', results);
			}
		},
		getTitle: function (folder) {
			let count = 0;
			for (let i = 0; i < this.notes.length; i++) {
				if (this.notes[i].folder === folder._id) {
					count += 1;
				}
			}
			if (count > 0) {
				return `(${count}) ${folder.title}`;
			} else {
				return folder.title;
			}
		},
		onFolderClick: function (folder) {
			this.$store.dispatch('dashboard/updateFolder', folder);
		},
		onEditFolder: function (folder) {
			this.$refs.editFolderModal.setFolder(folder);
			this.$bvModal.show('modal-editfolder');
		},
		onDeleteFolder: function (folder) {
			this.$store.dispatch('folder/removeFolder', folder._id);
			this.$emit('onFolderChange', null);
		},
		addFolder: function () {
			this.$bvModal.show('modal-addfolder');
		},
	},
};
</script>

<style lang="scss">
.c-list {
	margin-bottom: var(--spacer);
	&__item {
		min-height: var(--spacer);
		padding-left: calc(var(--size-h) + var(--size-h));
		padding-right: calc(var(--size-h) + var(--size-h));
		display: flex;
		align-items: center;
		color: var(--font-color-muted);
		transition: all var(--transition-time-sm) linear;

		&.drag {
			cursor: pointer;
			color: var(--font-color);
			//background-color: var(--hover-color);
			box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.3),
				inset 0 1px 8px 0 rgba(0, 0, 0, 0.2),
				inset 0 0 0 4px rgba($primary, 0.6) !important;
		}

		&.dull {
			.c-list__content {
				opacity: 0.9;
			}

			&.active {
				.c-list__content {
					opacity: 1;
				}
				.c-list__icon {
					opacity: 1;
				}
			}
		}

		&.interactive {
			cursor: pointer;
			&:hover {
				color: var(--font-color);
				background-color: var(--hover-color);
			}
		}
	}

	&__icon {
		opacity: 0.5;
		margin-right: var(--size-h);
		min-width: calc(var(--size) * 4);
		transition: opacity var(--transition-time-sm) linear;
	}

	&__content {
		flex-grow: 1;
		font-size: var(--font-size-sm);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.dropdown-toggle {
		display: flex;
		justify-content: center;
		align-items: center;
		width: calc(var(--size) * 6);
		height: calc(var(--size) * 6);
		padding: 0;
		border-radius: 0;
		box-shadow: none;
		background-color: transparent;

		svg {
			display: block;
		}

		&:hover,
		&:active {
			background-color: var(--hover-color-dark) !important;
			box-shadow: none;
		}

		&:after {
			content: none;
		}
	}
}
</style>
